import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * is Jira admin (not "is project admin")
 */
export const useIsAdmin = (): boolean => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.isAdmin) || false;
};
